import { BookNowStatuses } from 'Douleutaras/types';

export interface CategoryForm {
  attributes: Array<CategoryAttribute>;
  style: string;
  per_hour_model: boolean;
  price_per_hour: string;
  category: CategoryModel;
  id: number;
  days_off: Array<DayOfModel>;
}

interface CategoryAttributeConditionsItem {
  id: number;
  conditions: [];
  negated: boolean;
  condition_logic: 'and' | 'or';
}

export interface CategoryAttributeConditions {
  condition_logic: 'and' | 'or';
  conditions: Array<CategoryAttributeConditionsItem>;
}

export interface CategoryAttribute {
  attribute: CustomAttributeModel;
  choicerules: Array<string>;
  condition_hide: boolean;
  condition_logic: string;
  conditions: Array<CategoryAttributeConditions>;
  form_group_by: AttributeFormGroupBy;
  form_group_by_id: number;
  group: number;
  id: number;
  order: number;
  page: number;
  per_hour_component: boolean;
  price_type: string;
  style: string;
  unit_duration: number;
  visible: boolean;
  default_value: string | number | Array<number>;
  call_out_fee: string;
}

export enum AttributeModelDataType {
  CHOICE = 'choice',
  CHOICES = 'choices',
  TEXT = 'text',
  DATE = 'date'
}

export interface AttributeModel {
  call_out_fee: string; // "0.00"
  call_out_fee_title: string;
  choices: Array<ChoiceItem>;
  datatype: AttributeModelDataType;
  description: string;
  help_text: string;
  hidden: boolean;
  id: number;
  required: boolean;
  slug: string;
  title: string;
  seller_title: string;
  ui: string;
  placeholder: string;
  // datatype specific fields
  date_min_days_ahead?: number; // date control
  sub_title?: string; // plus-minus control
  sub_title_plural?: string; // plus-minus control
}

export interface AttributeFormGroupBy {
  id: number;
  title: string;
}

export interface CustomAttributeModel extends AttributeModel {
  form_group_by_title: string;
}

export interface ChoiceItem {
  default?: boolean;
  description?: string;
  help_text?: string;
  icon?: string;
  icon_hover?: string;
  id: number;
  order?: number;
  orig_price?: string;
  price?: string;
  title: string;
  value: number | string | null;
}

export interface CategoryModel {
  id?: number;
  cid?: number;
  slug?: string;
  title?: string;
  flow?: string;
  category_group_title?: string;
  can_use_labour_ticket?: boolean;
  image?: string;
  display_labour_ticket?: boolean;
  contacts_low?: number;
  contacts_high?: number;
  category_group?: CategoryGroup;
  geo_label?: string;
  geo_widget?: string;
  allocation?: string;
  credits_model?: boolean;
  subscription_model?: boolean;
  money_model?: boolean;
  active?: boolean;
  activate?: boolean;
  available_for_job?: boolean;
  available_for_pros?: boolean;
  available_for_new_pros?: boolean;
  search_sbs?: boolean;
  success_text_header?: string;
  success_text_footer?: string;
  target?: number;
  job_howitworks_template?: {
    contents: Array<CategoryContentTemplate>;
    id: number;
    title: string;
  };
  has_autodeals?: boolean;
  autodeals_success_text_header_singular?: string;
  autodeals_success_text_header_plural?: string;
  autodeals_success_text_footer_singular?: string;
  autodeals_success_text_footer_plural?: string;
  autoactive_success_text_footer?: string;
  remote?: boolean;
  in_form_job_title?: string;
  in_form_job_subtitle?: string;
  in_form_submit_button_text?: string;
  is_exit_popup_enabled?: boolean;
  enable_cleaning_discount_message?: boolean;
  order?: string;
  show_moneyback_guarantee?: boolean;
  quote_submitted_statuses?: Array<typeof BookNowStatuses>;
}

export interface CategoryContentTemplate {
  id: number;
  image: string;
  order: number;
  parent_template: number;
  text: string;
  title: string;
}

export interface CategoryGroup {
  slug: string;
  id: number;
  title: string;
  image: string; // url
}

export interface DayOfModel {
  date: string;
  counties: Array<string>;
}
